/* eslint-disable react-hooks/exhaustive-deps */
import { React, useEffect, useState } from "react"
import { Image, Media, Nav, Navbar, NavDropdown, Button } from "react-bootstrap"
// import { useLocation } from "react-router-dom";
// import logo from '../../images/logo-thaibev.svg'
import logo from '../../images/ic_role_manage.svg'
import iconavatar from '../../images/icon-avatar.svg'
import '../../styles/header.css'
import { useRecoilValue } from 'recoil';
import { history } from "../../router/route"
import { Cookies } from 'react-cookie'
import { ManageGroup } from "../Icon/ManageGroup";
import { DashboardActive } from "../Icon/DashboardActive";
import { ManageUser } from "../Icon/ManageUser";
import { ManageApp } from "../Icon/ManageApp";
import { accessToken } from "../../store"
import { logout } from "../../middleware"
import { Roles } from '../../utils/constants';
import { reqAppList } from '../../service/service';

const Header = (props) => {
    // let location = useLocation();
    const [user, setUser] = useState([])
    const token = useRecoilValue(accessToken)
    // const [appList, setAppList] = useState([])
    // const [groups, setGroups] = useState([])

    const cookies = new Cookies()

    // useEffect(() => {
    //     if (cookies.get('profile') !== null && cookies.get('profile') !== undefined) {
    //         setUser(cookies.get('profile'))
    //     }
    // }, [])

    useEffect(() => {
        setUser(cookies.get('profile'))
        reqAppList().then(res => {
            // setAppList(res.result)
        }).catch(err => {

        })
    }, []);

    // function reqMyGroup() {
    //     if (cookies.get('profile') !== null && cookies.get('profile') !== undefined) {
    //         reqUserGroup(cookies.get("profile").employeeid).then(res => {
    //             setGroups(res.result)
    //         }).catch(err => {
    //             console.log(err)
    //         })
    //     }
    // }

    // function renderMenus() {
    //     var arr = []
    //     if (cookies.get('profile') !== null && cookies.get('profile') !== undefined) {
    //         if (cookies.get('profile').super_role === Roles.SUPER) {
    //             // appList.forEach((element, index) => {
    //             //     arr.push(
    //             //         <li className="nav-item" key={index}>
    //             //             {/* <Nav.Link href={`${element.url}/authen?code=${token}`}> */}
    //             //             <Nav.Link target="_blank" rel="noopener noreferrer" href={`${element.url}`}>
    //             //                 <img src={element.icon} width="32" height="32" action="" alt="" />
    //             //                 <span className="nav-link-text ml-2">{element.name}</span>
    //             //             </Nav.Link>
    //             //         </li>
    //             //     )
    //             // });
    //         } else if (cookies.get('profile').super_role === Roles.MEMBER) {
    //             appList.forEach((ele, index) => {
    //                 groups.forEach((element, index) => {
    //                     element.apps.forEach((app, index) => {
    //                         if (ele.id === app.route.id) {
    //                             arr.push(
    //                                 <li className="nav-item" key={index}>
    //                                     <Nav.Link target="_blank" rel="noopener noreferrer" href={`${ele.url}`}>
    //                                         <img src={ele.icon} width="32" height="32" action="" alt="" />
    //                                         <span className="nav-link-text ml-2">{ele.name}</span>
    //                                     </Nav.Link>
    //                                 </li>
    //                             )
    //                         }

    //                     })
    //                 })
    //             })
    //         }
    //     }
    //     return arr
    // }

    // const user = useRecoilValue(personState)
    return (
        <>

            <Navbar collapseOnSelect className="sticky-top flex-md-nowrap border" bg="white" fixed="top" variant="light" expand="lg">
                {/* <Navbar.Brand href="/">{props.logo===undefined?<img src={logo} alt="" />:<img src={props.logo} alt=""/>} </Navbar.Brand> */}
                <Nav className="mr-auto">
                    {/* <Nav.Link href="#home">Home</Nav.Link> */}
                    <Media className="d-flex align-items-center">
                        <div>
                            {props.logo === undefined ? <img src={logo} alt="" /> : <img src={props.logo} alt="" />}
                        </div>

                        <Media.Body className="ml-3 mt--2">
                            <h5 className="mb-0">Management Role</h5>
                            <h6 className="mb-0"><small>Web Tool</small></h6>
                        </Media.Body>
                    </Media>
                </Nav>
                <Navbar.Collapse id="responsive-navbar-nav">

                    <div className="d-md-none sidebar-sticky pt-3">
                        {cookies.get('profile') ? (cookies.get('profile').super_role === Roles.SUPER ?
                            <ul className="navbar-nav mb-4">
                                <li className="nav-item">
                                    <Nav.Link href="/" className="active">
                                        <DashboardActive width="32" height="32" action="active" />
                                        <span className="nav-link-text ml-2">Dashboard</span>
                                    </Nav.Link>
                                </li>
                                <li className="nav-item">
                                    <Nav.Link href="/">
                                        <ManageUser width="32" height="32" action="" />
                                        <span className="nav-link-text ml-2">Manage Users</span>
                                    </Nav.Link>
                                </li>
                                <li className="nav-item">
                                    <Nav.Link href="/">
                                        <ManageApp width="32" height="32" action="" />
                                        <span className="nav-link-text ml-2">Manage Apps</span>
                                    </Nav.Link>
                                </li>
                                <li className="nav-item">
                                    <Nav.Link href="/">
                                        <ManageGroup width="32" height="32" action="" /><span className="nav-link-text ml-2">Manage Group</span></Nav.Link>

                                </li>
                            </ul> : '') : ''
                        }
                        {/* <!-- Heading --> */}

                        <h6 className="sidebar-heading d-flex justify-content-between align-items-center border-bottom pb-2 mt-4 mb-1 text-muted">
                            <span>CMS</span>

                        </h6>
                        <ul className="navbar-nav mb-md-3">
                            {/* {renderMenus()} */}
                        </ul>
                        <h6 className="d-md-none sidebar-heading d-flex justify-content-between align-items-center border-bottom pb-2 mt-4 mb-1 text-muted">
                            <span></span>

                        </h6>
                        <ul className="navbar-nav mb-md-3 d-md-none">
                            <li className="nav-item">
                                <Nav.Link href={`${process.env.REACT_APP_NOTI_URL}/authen?code=${token}`}>
                                    <Image style={{ width: 32, height: 32 }} roundedCircle src={iconavatar}
                                        onError={(e) => { e.target.onerror = null; e.target.src = iconavatar }} />
                                    <span className="nav-link-text ml-2">{user ? user.profile ? user.profile.sub : '' : ''}</span>
                                </Nav.Link>
                            </li>
                            <li className="nav-item">
                                <Nav.Link onClick={() => {
                                    cookies.remove('user', { domain: process.env.REACT_APP_DOMAIN })
                                    cookies.remove('profile', { domain: process.env.REACT_APP_DOMAIN })
                                    cookies.remove('tb_token', { domain: process.env.REACT_APP_DOMAIN })
                                    cookies.remove('user')
                                    logout()
                                    history.push('')
                                    history.go(0)
                                }}>
                                    {/* <Image style={{ width: 32, height: 32 }} roundedCircle src={iconavatar}
                                        onError={(e) => { e.target.onerror = null; e.target.src = iconavatar }} /> */}
                                    <span className="nav-link-text ml-2">Logout</span>
                                </Nav.Link>
                            </li>
                        </ul>
                    </div>
                </Navbar.Collapse>
                {/* <Navbar.Toggle className="d-md-none" onClick={() => setOpen(!open)} /> */}

                {props.navbarRight === undefined ?
                    (
                        <>
                            <Nav className="mr-2">

                                {/* Management Role */}
                                <Button variant="outline-success" onClick={() => {
                                    history.push({
                                        pathname: '/manage-user',
                                    })
                                }}>Manage Users</Button>
                            </Nav>
                            <Nav className="d-none d-sm-none d-md-block">
                                <NavDropdown title={<div style={{ display: "inline-block", position: 'relative', marginRight: 10 }}>
                                    <label>{user ? user.profile ? user.profile.sub : '' : ''} </label>
                                    <Image style={{ width: 40, height: 40 }} roundedCircle src={iconavatar}
                                        onError={(e) => { e.target.onerror = null; e.target.src = iconavatar }} />
                                </div>} id="nav-dropdown" hidden={cookies.get('user') ? cookies.get('user') === '' : true}>
                                    {/* <NavDropdown.Item href="/myevent" eventKey="4.1">MY EVENT</NavDropdown.Item> */}
                                    {/* <NavDropdown.Item href="/users/edit" eventKey="4.2">MY ACCOUNT</NavDropdown.Item> */}
                                    {/* <NavDropdown.Item href="/users/edit" eventKey="4.5">MY PROFILE</NavDropdown.Item> */}
                                    {/* <NavDropdown.Item href="/create-event" eventKey="4.4" >CREATE EVENT</NavDropdown.Item> */}
                                    {/* hidden={user !== undefined ? (user.role !== 'MEMBER' ? false : true) : true} */}
                                    {/* {console.log(cookies.get('profile'))} */}
                                    {/* <NavDropdown.Divider /> */}
                                    {/* <NavDropdown.Item eventKey="4.3" onClick={() => {
                                        cookies.remove('user', { domain: process.env.REACT_APP_DOMAIN })
                                        cookies.remove('user')
                                        cookies.remove('profile', { domain: process.env.REACT_APP_DOMAIN })
                                        cookies.remove('refresh_token')
                                        cookies.remove('tb_token', { domain: process.env.REACT_APP_DOMAIN })
                                        logout()
                                        history.push('')
                                        history.go(0)
                                    }}>Logout</NavDropdown.Item> */}
                                </NavDropdown>
                            </Nav>
                        </>
                    )
                    : props.navbarRight()
                }
                <Navbar.Toggle className="d-md-none" aria-controls="basic-navbar-nav" />
            </Navbar>
        </>
    )
}

export default Header